"use strict";
document.querySelectorAll('.close-toast-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
        var _a;
        var parent = (_a = e.currentTarget) === null || _a === void 0 ? void 0 : _a.parentElement;
        if (parent)
            parent.remove();
    });
});
